import axios from "axios";
import { LOCAL_URL } from "./../config";
export const readCard = () => {
    return axios.get(`${LOCAL_URL}/read-card`,{},{
        headers: {
            'Content-Type': 'application/json',
            // 'Authorization': 'Bearer ' + token
        },
    })
};
